module.exports = __webpack_public_path__ + "static/img/cgwjj.dce04779.png";